<script>
    import { createEventDispatcher } from "svelte";

    export let text;
    export let isPrimary = true;
    export let isSmall = false;

    const dispatch = createEventDispatcher();
</script>

<div
    on:click={() => dispatch("click")}
    class="headline-s pCursor fb_button {isPrimary
        ? 'primary_color'
        : 'secondary_color'}
        {isSmall ? 'button-small' : 'fb-button'}"
>
    <span>{text}</span>
</div>

<style>
    .fb_button {
        background: var(--black-100);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 24px;
    }

    .button-small {
        background: var(--black-100);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px 8px;
    }
    .primary_color {
        background-color: var(--black-100);
        color: var(--white-100);
    }

    .secondary_color {
        background-color: var(--white-64);
        backdrop-filter: blur(6px);
        color: var(--black-100);
        border: 1px var(--black-100) solid;
        box-sizing: border-box;
        -moz-box-sizing: border-box;
        -webkit-box-sizing: border-box;
    }

    .secondary_color:hover {
        border: 2px var(--black-100) solid;
    }

    .headline-s {
        font-size: 24px;
    }
</style>
